.badge {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 3px 9px;
  border-radius: var(--radius-sm);
  font-size: 11px;
  font-weight: 700;
  line-height: 1.4;
  white-space: nowrap;
  border: 1px solid transparent;
}

.ok {
  background: var(--color-ok-bg);
  color: #6bd996;
  border-color: var(--color-ok-border);
}

.warn {
  background: var(--color-warn-bg);
  color: var(--color-warn);
  border-color: var(--color-warn-border);
}

.error {
  background: var(--color-error-bg);
  color: var(--color-error);
  border-color: var(--color-error-border);
}

.info {
  background: var(--color-info-bg);
  color: var(--color-info);
  border-color: var(--color-info-border);
}

.neutral {
  background: var(--color-bg-surface);
  color: var(--color-text-muted);
  border-color: var(--color-border-strong);
}
